<template>
  <v-dialog max-width="1000" :value="modelValue" persistent @input="$emit('update:modelValue', $event)">
    <v-card class="no-scrollbar">
      <v-card-text>
        <v-row style="padding-top: 30px;">
          <v-col md="5" style="padding-top: 0; padding-right: 0px;">
            <p style="text-align: center; font-size: 20px; font-weight: 400; margin-bottom: 30px;">
              Scan this QR Code With Your Authenticator App
              <p class="qr-code-container">
                <qrcode-vue :value="urlQr" :size="200" />
              </p>
            </p>
          </v-col>
          <v-col md="7" style="padding-top: 0; padding-bottom: 30px;">
            <b>Keep This Account Name and Secret Key Safe for Backup in Case You Need It later.</b><br><br>
            <b>Account Name :</b><br>
            {{ email }}
            <v-icon class="fz-16" @click="copyClipboard(email)" small>mdi-content-copy</v-icon>
            <br>
            <p style="padding-top: 10px;">
              <b>Secret Key :</b><br>
              {{ secretQr }}
              <v-icon class="fz-16" @click="copyClipboard(secretQr)" small>mdi-content-copy</v-icon>
            </p>
            <p style="padding-top: 10px;"><b>Key Type :</b><br>Time Based</p>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="pt-0 pb-0">
        <p class="font-weight-bold mb-1">Please enter the generated security code below*</p>
        <v-otp-input style="justify-content: center;"
              ref="otpInput"
              input-classes="otp-input"
              :conditionalClass="['one', 'two', 'three', 'four', 'five', 'six']"
              separator=""
              inputType="letter-numeric"
              :num-inputs="6"
              v-model="otp"
              :should-auto-focus="true"
              :should-focus-order="true"
              @on-change="otpOnChange"
              @on-complete="otpOnComplete"
          />
        
        <p v-if="$v.otp.$error" class="text-error text-sm mt-1">{{ $v.otp.$errors[0].$message }}</p>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col>
            <v-btn depressed height="45" block class="text-white" color="accent" @click="onClose">Cancel</v-btn>
          </v-col>
          <v-col>
            <v-btn depressed height="45" block color="primary" @click="confirmTotp">Confirm</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import copy from "copy-to-clipboard";
import useVuelidate from "@vuelidate/core";
import { useNamespacedActions } from "vuex-composition-helpers";
import { PROFILE } from "../profile/namespace";
import { ref, getCurrentInstance } from "@vue/composition-api";
import { helpers } from "@vuelidate/validators";

export default {
  name: "MfaDialog",
  components: { QrcodeVue },
  props: {
    modelValue: Boolean,
    urlQr: String,
    secretQr: String,
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();

    const { validateTotp } = useNamespacedActions(PROFILE, ["validateTotp"]);

    // Langsung pakai ref untuk tiap variable
    const otp = ref("");
    const uid = ref(localStorage.getItem("uid"));
    const email = ref(localStorage.getItem("username"));

    const rules = {
      otp: {
        required: helpers.withMessage(
          "Couldn't be empty.",
          (value) => !!value && String(value).trim().length === 6
        ),
      },
    };

    const $v = useVuelidate(rules, { otp });

    const copyClipboard = (value) => {
      copy(value);
      proxy.$store.dispatch("auth/showSuccessToast", "Copied to clipboard!");
    };

    const otpOnChange = (val) => {
      otp.value = val;
    };

    const otpOnComplete = (val) => {
      otp.value = val;
    };

    const confirmTotp = async () => {
      $v.value.$touch();
      if ($v.value.$invalid) return;

      let payload = {
        user_id: uid.value,
        totp: otp.value,
        secret: props.secretQr,
        url: props.urlQr,
      };
      

      let resp = await validateTotp(payload);
      if (resp.status == 200) {
        emit("update:modelValue", false);
        proxy.$router.go(0);
      }
    };

    const onClose = () => {
      emit("update:modelValue", false);
    };

    return {
      otp,
      uid,
      email,
      $v,
      copyClipboard,
      otpOnChange,
      otpOnComplete,
      confirmTotp,
      onClose,
    };
  },
};
</script>
<style scoped>
.no-scrollbar {
  overflow: auto;
  scrollbar-width: none;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0 20px 0;
}
.otp-input-container >>> div {
  display: flex;
  align-items: center;
  max-width: 10%;
  background-color: #f0f3f6;
  margin: 0px 3px;
}
.otp-input-container >>> input {
  width: 100% !important;
  height: 50px;
  text-align: center;
}
</style>
